// extracted by mini-css-extract-plugin
export default {"skillsText":"Skills_skillsText__R-WBJ","progressColor":"Skills_progressColor__y7tjj","featureBox":"Skills_featureBox__ryzn0","icon":"Skills_icon__S50R7"};